<!-- PlateStockPopular.VUE -->
<template>
	<div>
		<div class="col">
			<div>
				<b-form-datepicker size="sm" :value="p_date" @input="handleDateInput" class="mb-1"
					today-button close-button locale="zh" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"></b-form-datepicker>
			</div>
			<div v-if="stocks.length">
				<div v-bind:key="data.index" v-for="(data) in stocks.slice()">
					<b-list-group>
						<div class="mb-1">
							<StockTextPopularItem @p_show_kline="p_show_kline" :rank="data.rank"
								:rank_diff="data.rank_diff" :stock_name="data.stock_name" :stock_code="data.stock_code"
								:pct="data.px_change_rate"></StockTextPopularItem>
						</div>
					</b-list-group>

				</div>
			</div>
			<div v-else>
				<span>loading</span>
			</div>
		</div>
		<!-- <div class="col-9"></div> -->
	</div>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	import StockTextPopularItem from 'components/stock/StockTextPopularItem.vue'
	export default {
		props: {
			plate_type: Number,
			plate_code: String,
			p_date: String,
		},
		data() {
			return {
				reqId: 0,
				stocks: []
			};
		},
		components: {
			StockTextPopularItem,
			// Navbar
		},
		mounted() {
			this.refresh_popular();
		},
		watch: {
			plate_code(newPlateCode, oldPlateCode) {
				if (newPlateCode !== oldPlateCode) {
					this.refresh_popular();
				}
			},
			p_date(newDate, oldDate) {
				if (newDate !== oldDate) {
					this.refresh_popular();
				}
			}
		},
		methods: {
			p_show_kline(stock_code, stock_name) {
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline', stock_code, stock_name)
			},

			refresh_popular() {
				if (!this.plate_code || !this.p_date) return;
				const curReqId = ++this.reqId;
				const curPlateCode = this.plate_code;
				const curDate = this.p_date;
				request_zzquant({
						url: '/v3/market/plates/'+this.plate_type+'/' + this.plate_code + '/stocks/rank?is_real=1&limit=100&date1=' + this
							.p_date
					})
					.then(res1 => {
						if (curReqId !== this.reqId || curPlateCode !== this.plate_code || curDate !== this.p_date) return;
						this.stocks = (res1 && res1.data && Array.isArray(res1.data.data)) ? res1.data.data : [];
					})
					.catch(err => {
						if (curReqId === this.reqId) {
							console.log(err);
							this.stocks = [];
						}
					});
			},

			handleDateInput(val) {
				if (val && val !== this.p_date) {
					this.$emit('date-selected', val);
				}
			},

		}
	};
</script>

<style>

</style>